import React from 'react';
import PopupEditTask from '../PopupEditTask/PopupEditTask';
import {PopupEditTasksContextProvider} from '../PopupEditTask/PopupEditTasksContext';
import PopupDeleteTask from '../PopupDeleteTask/PopupDeleteTask';
import ButtonDD from "../../../_common/components/ButtonDD";

export function TasksActionsColumnFormatter(cellContent) {
  const {taskID, taskTypeID} = cellContent;

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{
          itemContent: (
            <div className="d-flex justify-content-between align-items-center">
              <PopupEditTasksContextProvider>
                <PopupEditTask id={taskID} type={taskTypeID}/>
              </PopupEditTasksContextProvider>
              <PopupDeleteTask id={taskID}/>
            </div>
          )
        }
        ]}
      />
    </div>
  );
}
